import { z } from 'zod';
import { createZodFormResolver, FormProps } from '@mews/framework';
import { EnterpriseBuilderParametersType } from '@mews-commander/data-access';
import { EntitySelectionFlagEnum } from '../../utils';

export enum EnterpriseBuilderProFormFieldNames {
    EnterpriseId = 'enterpriseId',
    UniqueName = 'uniqueName',
    SubscriptionId = 'subscriptionId',
    ChainId = 'chainId',
    CityId = 'cityId',
    PropertyIdentifier = 'propertyIdentifier',
    ExportSettings = 'exportSettings',
}

const enterpriseCopySchema = z.object({
    [EnterpriseBuilderProFormFieldNames.EnterpriseId]: z.string().uuid(),
    [EnterpriseBuilderProFormFieldNames.UniqueName]: z.string(),
    [EnterpriseBuilderProFormFieldNames.SubscriptionId]: z.string().uuid(),
    [EnterpriseBuilderProFormFieldNames.ChainId]: z.string().uuid(),
    [EnterpriseBuilderProFormFieldNames.CityId]: z.string().uuid(),
    [EnterpriseBuilderProFormFieldNames.PropertyIdentifier]: z.string().uuid(),
    [EnterpriseBuilderProFormFieldNames.ExportSettings]: z
        .custom<typeof EntitySelectionFlagEnum.menuItems>()
        .optional(),
});

const newPropertySchema = enterpriseCopySchema.pick({
    [EnterpriseBuilderProFormFieldNames.UniqueName]: true,
    [EnterpriseBuilderProFormFieldNames.SubscriptionId]: true,
    [EnterpriseBuilderProFormFieldNames.ChainId]: true,
    [EnterpriseBuilderProFormFieldNames.CityId]: true,
    [EnterpriseBuilderProFormFieldNames.ExportSettings]: true,
});

const existingPropertySchema = enterpriseCopySchema.pick({
    [EnterpriseBuilderProFormFieldNames.PropertyIdentifier]: true,
    [EnterpriseBuilderProFormFieldNames.ExportSettings]: true,
});

export type EnterpriseBuilderProFormValues = z.infer<typeof enterpriseCopySchema>;

export const useEnterpriseCopyFormProps = (
    propertyType: EnterpriseBuilderParametersType
): Pick<FormProps<EnterpriseBuilderProFormValues>, 'resolver' | 'mode' | 'reValidateMode'> => {
    const resolver =
        propertyType === EnterpriseBuilderParametersType.NewEnterprise
            ? createZodFormResolver(newPropertySchema)
            : createZodFormResolver(existingPropertySchema);

    return {
        resolver,
        mode: 'onChange',
        reValidateMode: 'onChange',
    };
};
